export const GET_TOTAL_DEPOSITED_AMOUNT = "MARATHON_CHALLENGE_GET_TOTAL_DEPOSITED_AMOUNT";

